import type { LocalizedStatus } from '@common/types'
import { StatusType } from '@common/types'
import { OrderPaymentStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const orderPaymentStatusMessage = defineMessages({
  fullyPaid: {
    defaultMessage: 'Fully paid',
    description: 'order payment status message',
  },
  overpaid: {
    defaultMessage: 'Overpaid',
    description: 'order payment status message',
  },
  partiallyPaid: {
    defaultMessage: 'Partially paid',
    description: 'order payment status message',
  },
  unpaid: {
    defaultMessage: 'Unpaid',
    description: 'order payment status message',
  },
})

export function localizeOrderPaymentStatus(
  intl: IntlShape,
  status: OrderPaymentStatus,
): LocalizedStatus {
  switch (status) {
    case OrderPaymentStatus.UNPAID:
      return {
        localized: intl.formatMessage(orderPaymentStatusMessage.unpaid),
        status: StatusType.WARNING,
      }
    case OrderPaymentStatus.PARTIALLY_PAID:
      return {
        localized: intl.formatMessage(orderPaymentStatusMessage.partiallyPaid),
        status: StatusType.INFO,
      }
    case OrderPaymentStatus.FULLY_PAID:
      return {
        localized: intl.formatMessage(orderPaymentStatusMessage.fullyPaid),
        status: StatusType.SUCCESS,
      }
    case OrderPaymentStatus.OVERPAID:
      return {
        localized: intl.formatMessage(orderPaymentStatusMessage.overpaid),
        status: StatusType.WARNING,
      }
  }
}

export function translateOrderPaymentStatus(intl: IntlShape, status: OrderPaymentStatus): string {
  return localizeOrderPaymentStatus(intl, status).localized
}
